(function ($, window) {
    var tableWrapped = false;

    function addOpen($el) {
        $el.addClass('open');
    }

    function removeOpen($el) {
        $el.removeClass('open');
    }


    $(function () {
        if ($(window).width() < 768) {
            $('.tbl').wrap('<div class="tbl-responsive"></div>');
            tableWrapped = true;
        }


        var allinfoboxes = $('.info-text p:not(.far-text)');
        allinfoboxes.each(function (idx, el) {
            var self = $(el);
            var flipped = false;
            if (tableWrapped) {
                var icon = self.prev('.far-text');
                if (icon) {
                    var table = icon.closest('table');                
                    var offset = icon.offset().top - table.offset().top;

                    if (parseInt(offset) <  parseInt(self.height() + 57)) {
                        flipped = true;
                    }

                }
            }
            if (flipped) {
                self.addClass('flipped')
                self.css('top', '57px');
            } else {
                var newheight = (self.height() + 57) * -1;
                self.css('top', newheight + 'px');
            }
        });

        var fartexticons = $('.info-text .far-text');
        fartexticons.on('touchstart click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var sib = $(this).next('p:not(.far-text)');
            if (!sib.hasClass('open')) {
                allinfoboxes.each(function (idx, el) {
                    removeOpen($(el));
                });
                addOpen(sib)
            } else {
                sib.removeClass('open');
            }
        })

        fartexticons.on('mouseover', function (evt) {
            evt.preventDefault();
            var sib = $(this).next('p:not(.far-text)');
            if (!sib.hasClass('open')) {
                allinfoboxes.each(function (idx, el) {
                    removeOpen($(el));
                });
                addOpen(sib)
            }
        });

        allinfoboxes.on('mouseleave', function (evt) {
            evt.preventDefault();
            removeOpen($(this));
        });

        $(window).on('click', function () {
            allinfoboxes.each(function (idx, el) {
                removeOpen($(el));
            });
        });

    });


}(jQuery, window));